// extracted by mini-css-extract-plugin
module.exports = {"placeholderbar":"jgp-2rqzQ","animated":"jgp-1e5cM","placeholderbarpulse":"jgp-1WROZ"};